import { j as e } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { FormattedMessage as t } from "react-intl";
import { B as a } from "../../chunks/Button.Ccj-dDdM.js";
import { T as r } from "../../chunks/Text.BGhoO_e3.js";
const p = () => {
  const s = () => {
    window.location.reload();
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "tw-w-screen tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-24 tw-px-24 tw-py-48", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "tw-text-center", children: [
      /* @__PURE__ */ e.jsx(r, { element: "h1", typeface: "headline-5-b", children: /* @__PURE__ */ e.jsx(t, { id: "JqiqNj", defaultMessage: [{
        type: 0,
        value: "Something went wrong"
      }] }) }),
      /* @__PURE__ */ e.jsx(r, { children: /* @__PURE__ */ e.jsx(t, { id: "8CNKum", defaultMessage: [{
        type: 0,
        value: "More information about the likely cause for this error can be found in our "
      }, {
        type: 1,
        value: "link"
      }], values: {
        link: /* @__PURE__ */ e.jsx("a", { href: "https://support.peerspace.com/", target: "_blank", rel: "noopener noreferrer", className: "underline tw-text-purple-600", children: /* @__PURE__ */ e.jsx(t, { id: "FjVT/q", defaultMessage: [{
          type: 0,
          value: "support center"
        }] }) })
      } }) })
    ] }),
    /* @__PURE__ */ e.jsx(a, { appearance: "purple", className: "tw-body-1", onClick: s, children: /* @__PURE__ */ e.jsx(t, { id: "EJv8r2", defaultMessage: [{
      type: 0,
      value: "Refresh the page"
    }] }) })
  ] });
};
export {
  p as ErrorView
};
//# sourceMappingURL=index.js.map
